import { defineMessage } from 'services/localization';

export const messages = {
    followingBusinessAccountsText: defineMessage('youve_been_invited_to_t_owing_business_accounts'),
    whatHappenedAfterAcceptingText: defineMessage('after_accepting_the_inv__owner_and_the_managers'),
    accept: defineMessage('accept_1'),
    declineAllInvitations: defineMessage('decline_all_invitations'),
    alreadyAddedToAccount: defineMessage('you_have_already_been_a_ease_leave_practicename'),
    alreadyAddedToAccountWithoutPracticeName: defineMessage('you_have_already_been_a_urrent_business_account'),
    acceptTitle: defineMessage('pending_invitations_to_business_accounts'),
    acceptBtnTitle: defineMessage('accept_1'),
};
